<template>
  <Breadcrumb />
</template>
<script>
export default {
  name: "SystemLog",
  mounted() {
    this.$router.push({ name: "PageUnderConstruction" });
  },
};
</script>
